import { useEffect, useState } from "react";

import { Checkbox } from "../../components/Checkbox";
import { Input } from "../../components/Input";
import { Label } from "../../components/Label";

import styles from "../../../styles/avaliacoes.module.scss";

import classNames from "classnames/bind";
import { Hairline } from "../../components/Hairline";
import { Icon } from "../../components/core/Icon";
const css = classNames.bind(styles);

export default function BrandsFilter({
  environmentUnits,
  environmentBrands,
  onChangeBrandsAndUnits,
  filterParams,
}) {
  const [occurrences, setOccurrences] = useState(0);
  const [search, setSearch] = useState("");
  const [defaultBrands, setDefaultBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [brands, setBrands] = useState(filterParams.brands || []);
  const [units, setUnits] = useState(filterParams.units || []);

  useEffect(() => {
    const mappedBrands = Object.keys(environmentBrands || {}).map(
      (brandKey) => {
        const brandUnits = Object.values(environmentUnits).filter(
          (unit) => unit.brand_id === environmentBrands[brandKey].id
        );

        return {
          ...environmentBrands[brandKey],
          units: brandUnits,
        };
      }
    );
    setDefaultBrands(mappedBrands);
    setFilteredBrands(mappedBrands);
  }, []);

  useEffect(() => {
    if (onChangeBrandsAndUnits) {
      onChangeBrandsAndUnits(
        brands?.length === 0 ? null : brands,
        units?.length === 0 ? null : units
      );
    }
  }, [brands, units]);

  const searchBrands = (e) => {
    setSearch(e);

    const searchTerm = (e || "").toLowerCase();

    if (searchTerm.length > 1) {
      const searchFilteredBrands = defaultBrands.filter(
        (brand) => (brand.name || "").toLowerCase().indexOf(searchTerm) > -1
      );

      setOccurrences(searchFilteredBrands.length);
      setFilteredBrands(searchFilteredBrands);
    } else {
      setOccurrences(null);
      setFilteredBrands(defaultBrands);
    }
  };

  const Brand = ({ brand, selectedUnits, onToggleUnit, onCheckBrand }) => {
    const collapsed = brands.includes(brand.id);

    return (
      <div className={styles.brand} key={brand.name}>
        <div className={styles.header}>
          <Checkbox
            label={brand.name}
            checked={brands.includes(brand.id)}
            onChange={() => onCheckBrand(brand)}
          />
          <div className="d-flex align-center">
            <div className={styles.totalUnits}>{brand.units.length}</div>
            <div
              className={css({ chevron: true, rotate: collapsed })}
              onClick={() => {
                if (brands.indexOf(brand.id) > -1) {
                  setBrands(brands.filter((u) => u != brand.id));
                  setUnits((prev) =>
                    prev.filter((p, i) => p !== brand.units[i]?.id)
                  );
                } else {
                  setBrands((prevBrands) => [...prevBrands, brand.id]);
                }
              }}
            >
              <Icon name="chevron-down" />
            </div>
          </div>
        </div>

        <div className={css({ units: true, collapsed: collapsed })}>
          {brand.units.map((unit) => {
            return (
              <div className={styles.unit} key={unit.name}>
                <Checkbox
                  className="mb-10"
                  label={unit.name}
                  checked={selectedUnits.indexOf(unit.id) > -1}
                  onChange={() => onToggleUnit(unit.id)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <Input
        search
        value={search}
        records={occurrences}
        placeholder="Buscar por marcas..."
        prefix
        prefixWidth={20}
        className="pt-0"
        onChange={(e) => searchBrands(e.target.value)}
      />

      <Hairline />

      <Label bold className="mt-5 mb-15">
        Selecione as marcas e unidades:
      </Label>

      <div className={styles.brands}>
        {filteredBrands.map((brand) => {
          return (
            <Brand
              brand={brand}
              selectedUnits={units}
              onToggleUnit={(unitId) => {
                if (units.indexOf(unitId) > -1) {
                  setUnits(units.filter((u) => u != unitId));
                } else {
                  setUnits((prevUnits) => [...prevUnits, unitId]);
                }
              }}
              onCheckBrand={(brand) => {
                if (brands.indexOf(brand.id) > -1) {
                  setBrands(brands.filter((u) => u != brand.id));
                  setUnits((prev) =>
                    prev.filter((p, i) => p !== brand.units[i]?.id)
                  );
                } else {
                  setBrands([...brands, brand.id]);
                }
              }}
            />
          );
        })}
      </div>
    </>
  );
}
